import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bankCode"];
  static values = { banks: Object };

  connect() {
    console.log("School bank account controller connected");
  }

  bankSelected(event) {
    const bankId = event.target.value;
    const bankCodeField = this.bankCodeTarget;

    if (bankId && this.banksValue[bankId]) {
      const bank = this.banksValue[bankId];
      bankCodeField.value = bank.bank_code || "";
      bankCodeField.classList.remove("bg-gray-50");
      bankCodeField.classList.add("bg-white");
    } else {
      bankCodeField.value = "";
      bankCodeField.classList.add("bg-gray-50");
      bankCodeField.classList.remove("bg-white");
    }
  }
}
